export const DISPLAY_TIME = 5000;
export const ENTER_AND_EXIT_TIMEOUT = 500; // same value (or 0.5s) must be in CSS
